export const Icons = {
  roundedRight: (props) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M1.375 0.75C1.375 0.75 6.625 3.858 6.625 6C6.625 8.14125 1.375 11.25 1.375 11.25"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="dark:text-white"
        ></path>
      </svg>
    );
  },
  roundedLeft: (props) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="rotate-180"
        {...props}
      >
        <path
          d="M1.375 0.75C1.375 0.75 6.625 3.858 6.625 6C6.625 8.14125 1.375 11.25 1.375 11.25"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="dark:text-white"
        ></path>
      </svg>
    );
  },
  close: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-6"
      {...props}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
  ),
  download: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      id="Download-Bottom--Streamline-Ultimate"
      height={24}
      width={24}
      {...props}
    >
      <desc>Download Bottom Streamline Icon: https://streamlinehq.com</desc>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12.001 3.75v12"
        strokeWidth="1.5"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m7.501 11.25 4.5 4.5 4.5 -4.5"
        strokeWidth="1.5"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M23.251 15.75v1.5c0 0.7956 -0.3161 1.5587 -0.8787 2.1213 -0.5626 0.5626 -1.3257 0.8787 -2.1213 0.8787h-16.5c-0.79565 0 -1.55871 -0.3161 -2.12132 -0.8787 -0.56261 -0.5626 -0.878681 -1.3257 -0.878681 -2.1213v-1.5"
        strokeWidth="1.5"
      />
    </svg>
  ),
  file: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-0.5 -0.5 16 16"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      id="File--Streamline-Lucide"
      height={16}
      width={16}
      {...props}
    >
      <desc>File Streamline Icon: https://streamlinehq.com</desc>
      <path
        d="M9.375 1.25H3.75a1.25 1.25 0 0 0 -1.25 1.25v10a1.25 1.25 0 0 0 1.25 1.25h7.5a1.25 1.25 0 0 0 1.25 -1.25V4.375Z"
        strokeWidth={1}
      />
      <path d="M8.75 1.25v2.5a1.25 1.25 0 0 0 1.25 1.25h2.5" strokeWidth={1} />
    </svg>
  ),
  search: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="-0.5 -0.5 16 16"
      id="Magnifer--Streamline-Solar.svg"
      height={16}
      width={16}
      {...props}
    >
      <desc>Magnifer Streamline Icon: https://streamlinehq.com</desc>
      <g id="Line Duotone/Search/Magnifer">
        <path
          id="Vector"
          stroke="currentColor"
          d="M7.158125 13.653500000000001C10.7454375 13.653500000000001 13.653500000000001 10.7454375 13.653500000000001 7.158125C13.653500000000001 3.570875 10.7454375 0.6628125 7.158125 0.6628125C3.570875 0.6628125 0.6628125 3.570875 0.6628125 7.158125C0.6628125 10.7454375 3.570875 13.653500000000001 7.158125 13.653500000000001Z"
          strokeWidth={1}
        />
        <path
          id="Vector_2"
          stroke="currentColor"
          strokeLinecap="round"
          d="M11.944187500000002 11.944187500000002L14.337187499999999 14.337187499999999"
          strokeWidth={1}
        />
      </g>
    </svg>
  ),
  messageTick: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={13}
      height={13}
      viewBox="0 0 13 13"
      {...props}
    >
      <image
        id="Check-Double-Thick--Streamline-Flex"
        width={13}
        height={13}
        xlinkHref="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAABRUlEQVQokX3SvWsVQRQF8N9T0SIRbCwEIQSmiWgRjSBYC7Jr2l0Q7Q2x8D9IBAUt/GgEbQQtkoz9EJCEVClEEBtJyG5nZ6UWEQR9MrKRlTwyMM2959xz7sdgOBwa9cq6PYxbOIFnKYave7BDBxBeo8Y5LPbz+5TKuh3gFU7jGn7gKOZwCS9GKd3G2UxIMex2sae4jnXEI2XdTuIGNvEed3PFHuE+LuAKLuJ3VnqLk3iJMUynGHY6q1dxE7M4j5WsOCiq5jtmMrCs21NYwBc8xgfMYxvvMiHFsJaV7mSvZd2Od8BfOINPaFIMq3iOR5nwb3pl3V7uKi3jIx7gCZZwrLM+lWL4+bfLTNr7RdVMFlXzuaiauV7sTVE1833cqD0FbHQLzda2MNG/iJFnVNbtFFI31YcphnsHXkSPmId0PMXw7b8E/gAWNImv5FwdqAAAAABJRU5ErkJggg=="
      />
    </svg>
  ),
  microphone: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      height={14}
      width={14}
      id="Voice-Mail-Off--Streamline-Flex.svg"
      {...props}
    >
      <desc>Voice Mail Off Streamline Icon: https://streamlinehq.com</desc>
      <g id="voice-mail-off--mic-audio-mike-music-microphone-mute-off">
        <path
          id="Subtract"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M8.19187 9.02844c1.1575 -0.39689 1.99943 -1.54 2.07723 -2.80612 0.0278 -0.45378 0.0463 -0.91398 0.0463 -1.37955 0 -0.46556 -0.0185 -0.92577 -0.0463 -1.37954C10.1756 1.9417 8.9786 0.597828 7.45657 0.513144 7.30517 0.50472 7.15295 0.5 6.99997 0.5c-0.15297 0 -0.30519 0.00472 -0.45659 0.013144C5.02134 0.597828 3.82431 1.9417 3.73088 3.46323c-0.01914 0.31168 -0.03385 0.62639 -0.04118 0.94379"
          strokeWidth={1}
        />
        <path
          id="Vector"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M6.93555 11.5405V13.5"
          strokeWidth={1}
        />
        <path
          id="Vector_2"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M1.00146 6.90356c0.4795 2.98465 2.56424 4.63704 5.93416 4.63704 0.29369 0 0.57763 -0.0126 0.85159 -0.0375m5.08259 -4.59954c-0.2965 1.84547 -1.2067 3.18154 -2.655 3.93264"
          strokeWidth={1}
        />
        <path
          id="Vector_3"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M0.5 0.5c4.57955 5.86626 7.008 8.26297 13 13"
          strokeWidth={1}
        />
      </g>
    </svg>
  ),
  cameraOn: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Camera-1--Streamline-Flex.svg"
        {...props}
      >
        <desc>Camera 1 Streamline Icon: https://streamlinehq.com</desc>
        <g id="camera-1--photos-picture-camera-photography-photo-pictures">
          <path
            id="Union"
            fill="#b6c0f3"
            d="m3.84712 3.3531 0.61936 -1.20854c0.14362 -0.28024 0.41062 -0.47875 0.72265 -0.52121 1.21939 -0.16593 2.40242 -0.16593 3.62181 0 0.31202 0.04246 0.57902 0.24097 0.72264 0.52121l0.61942 1.20855c0.3543 0.02735 0.7056 0.05647 1.0538 0.08532 0.05 0.00414 0.0998 0.00827 0.1496 0.01239 0.9561 0.07912 1.743 0.7909 1.8849 1.70911 0.1351 0.87401 0.2587 1.77484 0.2587 2.69524 0 0.9204 -0.1236 1.82123 -0.2587 2.69523 -0.1419 0.9182 -0.9288 1.63 -1.8849 1.7091 -0.0498 0.0041 -0.0996 0.0083 -0.1496 0.0124 -1.35864 0.1126 -2.76562 0.2292 -4.2068 0.2292 -1.44118 0 -2.84814 -0.1166 -4.20682 -0.2292 -0.04992 -0.0041 -0.09977 -0.0083 -0.14955 -0.0124 -0.95615 -0.0791 -1.743002 -0.7909 -1.884914 -1.7091C0.623634 9.6764 0.5 8.77558 0.5 7.85517c0 -0.9204 0.123634 -1.82123 0.258716 -2.69524 0.141912 -0.91821 0.928764 -1.62999 1.884914 -1.70911 0.04977 -0.00412 0.09961 -0.00825 0.14951 -0.01239 0.34823 -0.02885 0.69964 -0.05798 1.05398 -0.08533Z"
            strokeWidth={1}
          />
          <path
            id="Union_2"
            stroke="#313b6b"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m3.84712 3.3531 0.61936 -1.20854c0.14362 -0.28024 0.41062 -0.47875 0.72265 -0.52121 1.21939 -0.16593 2.40242 -0.16593 3.62181 0 0.31202 0.04246 0.57902 0.24097 0.72264 0.52121l0.61942 1.20855c0.3543 0.02735 0.7056 0.05647 1.0539 0.08532 0.0499 0.00414 0.0997 0.00827 0.1495 0.01239 0.9561 0.07912 1.743 0.7909 1.8849 1.70911 0.1351 0.87401 0.2587 1.77484 0.2587 2.69524 0 0.9204 -0.1236 1.82123 -0.2587 2.69523 -0.1419 0.9182 -0.9288 1.63 -1.8849 1.7091 -0.0498 0.0041 -0.0996 0.0083 -0.1496 0.0124 -1.35865 0.1126 -2.76562 0.2292 -4.2068 0.2292 -1.44118 0 -2.84814 -0.1166 -4.20682 -0.2292 -0.04992 -0.0041 -0.09977 -0.0083 -0.14955 -0.0124 -0.95615 -0.0791 -1.743002 -0.7909 -1.884914 -1.7091C0.623634 9.6764 0.5 8.77558 0.5 7.85517c0 -0.9204 0.123634 -1.82123 0.258716 -2.69524 0.141912 -0.91821 0.928764 -1.62999 1.884914 -1.70911 0.04977 -0.00412 0.09961 -0.00825 0.14951 -0.01239 0.34823 -0.02885 0.69964 -0.05798 1.05398 -0.08533Z"
            strokeWidth={1}
          />
          <path
            id="Vector"
            fill="#ffffff"
            d="M7 9.90216c1.44 0 2.25 -0.81 2.25 -2.25s-0.81 -2.25 -2.25 -2.25 -2.25 0.81 -2.25 2.25 0.81 2.25 2.25 2.25Z"
            strokeWidth={1}
          />
          <path
            id="Vector_2"
            stroke="#313b6b"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M7 9.90216c1.44 0 2.25 -0.81 2.25 -2.25s-0.81 -2.25 -2.25 -2.25 -2.25 0.81 -2.25 2.25 0.81 2.25 2.25 2.25Z"
            strokeWidth={1}
          />
        </g>
      </svg>
    );
  },
  cameraOff: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        height={14}
        width={14}
        id="Camera-Disabled--Streamline-Flex.svg"
        {...props}
      >
        <desc>Camera Disabled Streamline Icon: https://streamlinehq.com</desc>
        <g id="camera-disabled--photos-picture-camera-photography-photo-pictures-disabled-off">
          <path
            id="Subtract"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4.94336 8.72546c0.18901 0.45093 0.51368 0.78003 0.9604 0.9737m-0.67413 -3.59634c0.38109 -0.45722 0.98118 -0.70066 1.77061 -0.70066 1.44 0 2.25 0.81 2.25 2.25 0 0.76508 -0.22865 1.35231 -0.65895 1.73472"
            strokeWidth={1}
          />
          <path
            id="Subtract_2"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M11.8454 12.1605c0.7254 -0.2384 1.2791 -0.8543 1.3959 -1.6101 0.1351 -0.874 0.2587 -1.77483 0.2587 -2.69523 0 -0.9204 -0.1236 -1.82123 -0.2587 -2.69524 -0.1419 -0.91821 -0.9288 -1.62999 -1.8849 -1.70911l-0.1496 -0.01239c-0.3482 -0.02885 -0.6995 -0.05797 -1.0538 -0.08532l-0.61942 -1.20855c-0.14362 -0.28024 -0.41062 -0.47875 -0.72264 -0.52121 -1.21939 -0.16593 -2.40242 -0.16593 -3.62181 0 -0.31203 0.04246 -0.57903 0.24097 -0.72265 0.52121L3.84712 3.3531c-0.32961 0.02545 -0.65667 0.05242 -0.981 0.07929M0.968726 4.53485c-0.103362 0.19219 -0.175622 0.40257 -0.21001 0.62508C0.623634 6.03394 0.5 6.93477 0.5 7.85517c0 0.92041 0.123634 1.82123 0.258716 2.69523 0.141912 0.9182 0.928764 1.63 1.884914 1.7091l0.14955 0.0124c1.35868 0.1126 2.76564 0.2292 4.20682 0.2292 0.60303 0 1.20007 -0.0204 1.79009 -0.0524"
            strokeWidth={1}
          />
          <path
            id="Vector"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M0.5 0.5c4.39562 5.63065 7.24865 8.45323 13 13"
            strokeWidth={1}
          />
        </g>
      </svg>
    );
  },
  hangup: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        height={14}
        width={14}
        id="Hang-Up-1--Streamline-Flex.svg"
        {...props}
      >
        <desc>Hang Up 1 Streamline Icon: https://streamlinehq.com</desc>
        <g id="hang-up-1--android-phone-mobile-device-smartphone-iphone-telephone-hang-up">
          <path
            id="Intersect"
            fill="currentColor"
            d="M1.25739 10.0063C0.485379 9.92642 -0.0990069 9.24831 0.0140232 8.48013c0.0464494 -0.31568 0.1132568 -0.62516 0.1861378 -1.2742C0.382533 5.58183 1.6904 4.27397 3.31528 4.09879c1.19951 -0.12933 2.43098 -0.23872 3.68638 -0.23977 1.25539 -0.00105 2.48669 0.10628 3.68594 0.23359 1.6246 0.17247 2.9303 1.47814 3.11 3.10194 0.0747 0.67589 0.1436 0.97875 0.1897 1.30659 0.1042 0.74214 -0.4441 1.40784 -1.1886 1.49592 -0.8454 0.10004 -1.7242 0.11184 -2.5674 0.13574 -0.46769 0.0133 -0.861 -0.35056 -0.89637 -0.81699 -0.02795 -0.36843 -0.05589 -0.60395 -0.07658 -1.26231 -1.64538 -0.41752 -2.90433 -0.40883 -4.5204 0.00378 -0.02189 0.66142 -0.05039 0.89748 -0.07908 1.26895 -0.03599 0.46596 -0.42902 0.83007 -0.89602 0.81437 -0.82699 -0.0277 -1.67735 -0.0487 -2.50546 -0.1343Z"
            strokeWidth={1}
          />
        </g>
      </svg>
    );
  },
  phone: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        height={14}
        width={14}
        id="Phone--Streamline-Flex.svg"
        {...props}
      >
        <desc>Phone Streamline Icon: https://streamlinehq.com</desc>
        <g id="phone--android-phone-mobile-device-smartphone-iphone">
          <path
            id="Intersect"
            fill="currentColor"
            d="M9.90731 0.378847c0.70609 -0.573701 1.75249 -0.496011 2.29549 0.234366 0.2231 0.300147 0.4243 0.612027 0.9018 1.210387 1.195 1.49727 1.195 3.66529 -0.0066 5.15726 -0.887 1.10139 -1.817 2.21276 -2.8567 3.25414 -1.03964 1.0414 -2.14915 1.973 -3.2487 2.8615 -1.48947 1.2036 -3.65386 1.2036 -5.14864 0.0066 -0.62218 -0.4982 -0.930271 -0.6922 -1.240178 -0.9257 -0.7015334 -0.5287 -0.798817 -1.5349 -0.254709 -2.22507 0.617778 -0.78356 1.336337 -1.52174 2.015407 -2.24048 0.37661 -0.39863 1.0042 -0.42302 1.42012 -0.06574 0.32853 0.28221 0.5469 0.45425 1.10972 0.98278 1.70982 -1.0177 2.74608 -2.06837 3.74355 -3.74982 -0.53006 -0.56635 -0.7021 -0.78563 -0.98621 -1.1173 -0.35638 -0.41604 -0.33237 -1.04355 0.06768 -1.41764C8.42776 1.68166 9.14996 0.99424 9.90731 0.378847Z"
            strokeWidth={1}
          />
        </g>
      </svg>
    );
  },
  microphoneFill: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        height={14}
        width={14}
        id="Voice-Mail-Off--Streamline-Flex.svg"
        {...props}
      >
        <desc>Voice Mail Off Streamline Icon: https://streamlinehq.com</desc>
        <g id="voice-mail-off--mic-audio-mike-music-microphone-mute-off">
          <path
            id="Subtract"
            fill="#b6c0f3"
            d="M7.57056 9.16366c1.46746 -0.14351 2.60744 -1.458 2.69854 -2.94134 0.0279 -0.45378 0.0463 -0.91398 0.0463 -1.37955 0 -0.46556 -0.0184 -0.92577 -0.0463 -1.37954C10.1757 1.9417 8.97863 0.597828 7.45659 0.513144 7.3052 0.50472 7.15298 0.5 7 0.5s-0.30519 0.00472 -0.45659 0.013144C5.02137 0.597828 3.82433 1.9417 3.7309 3.46323c-0.02786 0.45377 -0.04633 0.91398 -0.04633 1.37954 0 0.10331 0.00091 0.20634 0.00263 0.30911 1.28523 1.47429 2.50544 2.7361 3.88336 4.01178Z"
            strokeWidth={1}
          />
          <path
            id="Subtract_2"
            stroke="#313b6b"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8.19187 9.02844c1.1575 -0.39689 1.99943 -1.54 2.07723 -2.80612 0.0278 -0.45378 0.0463 -0.91398 0.0463 -1.37955 0 -0.46556 -0.0185 -0.92577 -0.0463 -1.37954C10.1756 1.9417 8.9786 0.597828 7.45657 0.513144 7.30517 0.50472 7.15295 0.5 6.99997 0.5c-0.15297 0 -0.30519 0.00472 -0.45659 0.013144C5.02134 0.597828 3.82431 1.9417 3.73088 3.46323c-0.01914 0.31168 -0.03385 0.62639 -0.04118 0.94379"
            strokeWidth={1}
          />
          <path
            id="Vector"
            stroke="#313b6b"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6.93555 11.5405V13.5"
            strokeWidth={1}
          />
          <path
            id="Vector_2"
            stroke="#313b6b"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M1.00146 6.90356c0.4795 2.98465 2.56424 4.63704 5.93416 4.63704 0.29369 0 0.57763 -0.0126 0.85159 -0.0375m5.08259 -4.59954c-0.2965 1.84547 -1.2067 3.18154 -2.655 3.93264"
            strokeWidth={1}
          />
          <path
            id="Vector_3"
            stroke="#313b6b"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M0.5 0.5c4.57955 5.86626 7.008 8.26297 13 13"
            strokeWidth={1}
          />
        </g>
      </svg>
    );
  },
  checkBoxTick: (props) => (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_28_1206)">
        <path
          d="M1.02539 7.24369L4.64331 10.9747C6.34577 6.08424 7.7636 3.93826 10.9747 1.02539"
          stroke="currentColor"
          strokeWidth="1.9278"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_28_1206">
          <rect width={12} height={12} fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  ),
  rejectCrossIcon: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 20 20"
        id="Delete-Square--Streamline-Flex-Remix"
        height="20"
        width="20"
        {...props}
      >
        <desc>Delete Square Streamline Icon: https://streamlinehq.com</desc>
        <g id="delete-square--button-remove-buttons-add-square-delete-cross-x-mathematics-multiply-math">
          <path
            id="Union"
            fill="currentColor"
            fill-rule="evenodd"
            d="M14.502857142857142 2.397685714285714c-3.0304714285714285 -0.33977142857142856 -5.975257142857144 -0.33977142857142856 -9.005657142857142 0 -1.5981857142857143 0.1792 -2.8938857142857146 1.479914285714286 -3.0655428571428573 3.0937714285714284C2.273271428571429 6.980657142857142 2.142857142857143 8.480657142857144 2.142857142857143 10c0 1.519342857142857 0.1304142857142857 3.019342857142857 0.2888 4.508571428571429 0.17165714285714287 1.6138571428571429 1.4673571428571428 2.9145714285714286 3.0655428571428573 3.093714285714286 3.0304 0.33985714285714286 5.9752 0.33985714285714286 9.005657142857142 0 1.5981428571428573 -0.17914285714285716 2.893857142857143 -1.479857142857143 3.0654285714285714 -3.093714285714286C17.726714285714287 13.019342857142858 17.857142857142858 11.519342857142856 17.857142857142858 10c0 -1.519342857142857 -0.13042857142857145 -3.019342857142857 -0.28885714285714287 -4.508542857142857 -0.17157142857142857 -1.6138571428571429 -1.467285714285714 -2.9145714285714286 -3.0654285714285714 -3.0937714285714284ZM5.298228571428571 0.6230957142857143c3.162642857142857 -0.3546042857142857 6.2409 -0.3546042857142857 9.403485714285715 0 2.4337142857142857 0.2728714285714286 4.382428571428571 2.2357185714285714 4.642285714285714 4.67949C19.504285714285714 6.808814285714286 19.642857142857142 8.384085714285714 19.642857142857142 10c0 1.6159 -0.13857142857142857 3.1911714285714288 -0.2988571428571429 4.6974285714285715 -0.2598571428571429 2.4437142857142855 -2.2085714285714286 4.406571428571429 -4.642285714285714 4.679428571428572 -3.1625857142857146 0.3547142857142857 -6.240842857142858 0.3547142857142857 -9.403485714285715 0 -2.4336714285714285 -0.27285714285714285 -4.3823428571428575 -2.2357142857142858 -4.642264285714286 -4.679428571428572C0.4957614285714286 13.191171428571428 0.35714285714285715 11.615900000000002 0.35714285714285715 10c0 -1.6159142857142859 0.13861857142857142 -3.1911857142857145 0.29882142857142857 -4.697414285714286C0.9158842857142857 2.8588142857142858 2.8645571428571426 0.8959671428571429 5.298228571428571 0.6230957142857143ZM14.122157142857143 5.878128571428572c0.4184142857142857 0.4184142857142857 0.4184142857142857 1.0968142857142857 0 1.5152285714285714L11.515457142857143 10.000057142857143l2.6067 2.6067142857142858c0.4184142857142857 0.4184142857142857 0.4184142857142857 1.0968 0 1.5152285714285714 -0.4184142857142857 0.4184285714285714 -1.0968142857142857 0.4184285714285714 -1.5152285714285714 0L10.000228571428572 11.515285714285715 7.393585714285715 14.121928571428572c-0.4184142857142857 0.41835714285714287 -1.0968 0.41835714285714287 -1.5152285714285714 0 -0.4184142857142857 -0.4184285714285714 -0.4184142857142857 -1.0968142857142857 0 -1.5152285714285714L8.485 10.000057142857143 5.878357142857142 7.393428571428571c-0.4184142857142857 -0.4184285714285714 -0.4184142857142857 -1.0968142857142857 0 -1.5152285714285714 0.4184285714285714 -0.4184285714285714 1.0968142857142857 -0.4184285714285714 1.5152285714285714 0l2.6066428571428575 2.6066285714285717 2.6067 -2.6067c0.4184142857142857 -0.4184142857142857 1.0968142857142857 -0.4184142857142857 1.5152285714285714 0Z"
            clip-rule="evenodd"
            stroke-width="1.4286"
          ></path>
        </g>
      </svg>
    );
  }
};
